import {useFetch} from "../useFetch";
import {Geofence} from "../../types/api/guide/geofence.types";
import {geofenceService} from "../../services/guide/geofence-service";

export const useFetchGetGeofenceById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<Geofence>(
            geofenceService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as Geofence, isLoading, error };
}